import styled from "styled-components";
import React from "react";
import { IconPhone } from "../../Assets/IconPhone";
import { IconSMS } from "../../Assets/IconSMS";

const StyleCss = styled.div`
  max-width: 1100px;
  margin: 1rem auto;
  width: calc(100% - 0) !important;
  position: relative;
  background-color: #ffffff;
  border-radius: 24px;
  border: 1px solid var(--prime-2);
  overflow: hidden;
  padding: 1rem;
  @media (max-width: 850px){
    margin: 1rem -0.5rem;
  }
  
  .top-box {
    margin: 0 0 1rem;
    background-color: var(--prime-2);
    border-radius: 16px;
    padding: 1rem;
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    color: #ffffff;
    @media (max-width: 850px){
      flex-direction: column-reverse;
    }
    .main-data {
      display: flex;
      flex-direction: column;
      .center-name {
        position: relative;
        z-index: 1;
        font-size: 2rem;
        font-weight: 700;
        display: flex;
        margin: 1rem 0 0.5rem;
        @media (max-width: 850px){
          font-size: 1.7rem;
        }
      }
      .center-pos {
        position: relative;
        z-index: 1;
        font-size: 1.2rem;
        font-weight: 700;
        display: flex;
        margin: 0rem 0 1rem;
        @media (max-width: 850px){
          font-size: 1rem;
        }
      }
      .actions {
        display: flex;
        gap: 0.5rem;
        align-items: center;
        @media (max-width: 850px){
          flex-direction: column;
          align-items: unset;
        }
        .normal {
          border: 1px solid #ffffff;
          padding: 0.5rem ;
          text-decoration: none;
          color: inherit;
          display: flex;
          align-items: center;
          gap: 0.4rem;
          border-radius: 8px;
        }
        svg {
          fill: #ffffff;
          width: 24px;
          height: 24px;
        }
      }
    }
    .expand {
      flex-grow: 1;
    }
    .image {
      width: 200px;
      height: 200px;
      overflow: hidden;
      border: 1px solid #ffffff;
      border-radius: 8px;
      @media (max-width: 850px){
        max-width: unset;
        width: 120px;
        height: 120px;
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    img {
      width: 100%;
      display: block;
    }
  }
  
  .data-main {
    position: relative;
    z-index: 1;
    display: flex;
    flex-wrap: wrap;
    padding: 0 1rem;
    @media (max-width: 850px){
      padding: 0 0.3rem;
    }
    .normal {
      width: 50%;
      margin: 0.5rem 0;
      text-decoration: none;
      color: inherit;
      @media (max-width: 850px){
        width: 100%;
      }
    }
  }
  .block {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: row;
    .expand {
      flex-grow: 1;
    }
    &.first {
      margin-top: 1rem;
      border-radius: 1rem;
      overflow: hidden;
      background-color: #f3822555;
      padding: 1.5rem;
      position: relative;
      align-items: center;
      @media (max-width: 850px){
        flex-direction: column-reverse;
        gap: 1rem;
      }
      .side-color {
        position: absolute;
        inset: 0 auto 0 0;
        width: 1rem;
        background-color: var(--prime-2);
      }
      .base-data {
        max-width: 50%;
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        @media (max-width: 850px){
          max-width: unset;
        }
        .name {
          font-size: 2rem;
          font-weight: 700;
        }
        .normal {
          margin-left: 1px;
          font-weight: 500;
        }
      }
      .image {
        width: 200px;
        height: 200px;
        overflow: hidden;
        border: 1px solid var(--n-grey-11);
        border-radius: 8px;
        @media (max-width: 850px){
          max-width: unset;
          width: 120px;
          height: 120px;
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
    &.title {
      margin: 1.5rem 0.8rem 0.5rem;
      font-size: 1.3rem;
      font-weight: 600;
      gap: 0.2rem;
      align-items: center;
      @media (max-width: 850px){
        margin: 1.5rem 0 0.5rem;
      }
      svg {
        display: block;
        width: 32px;
        height: 32px;
        fill: var(--prime-2);
      }
    }
    &.text {
      margin: 0 1rem 0.5rem;
      @media (max-width: 850px){
        margin: 0 0.3rem 0.5rem;
      }
      font-size: 1rem;
      font-weight: 400;
    }
    &.items{
      margin: 0 1rem 0.5rem;
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      @media (max-width: 850px){
        margin: 0 0.3rem 0.5rem;
      }
      .row {
        margin: 2rem 0;
      }
      .data {
        margin: 0 0;
        display: flex;
        justify-content: space-between;
        /* border-bottom: 1px solid lightgray; */
        padding: 0.6rem 0;
        :last-child{
          border-bottom: none;
        }
        .right {
          display: flex;
          flex-direction: column;
          gap: 0.5rem;
          .top {
            font-size: 1.1rem;
          }
        }
      }
    }
  }
  
`;


function ResumeDataShow(props) {
  let data = props.resume
  return (
    <StyleCss>
      <div className="top-box">
        <div className="main-data">
          <div className="center-name">
            {data.Name}
          </div>
          <div className="center-pos">
            Farazandishan . {data.Position}
          </div>
          <div className="actions">
            <a href={"tel:" + data.Mobile} className="normal"><IconPhone/> {data.Mobile}</a>
            <a href={"mailto:" + data.Email} className="normal"><IconSMS/> {data.Email}</a>
          </div>
        </div>
        <div className="expand"></div>
        <div className="image">
          <img src={data.image} alt={"resume avatar"}/>
        </div>
      </div>
      <div className="block title">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.07 8.95005C12.03 8.95005 11.97 8.95005 11.92 8.95005C10.87 8.91005 10.04 8.06005 10.04 7.00005C10.04 5.92005 10.91 5.05005 11.99 5.05005C13.07 5.05005 13.94 5.93005 13.94 7.00005C13.95 8.06005 13.12 8.92005 12.07 8.95005Z"/>
        <path d="M9.24994 11.96C7.91994 12.85 7.91994 14.3 9.24994 15.19C10.7599 16.2 13.2399 16.2 14.7499 15.19C16.0799 14.3 16.0799 12.85 14.7499 11.96C13.2399 10.96 10.7699 10.96 9.24994 11.96Z"/>
        <path opacity="0.4" d="M18 2H6C4.34 2 3 3.33 3 4.97V15.88C3 17.52 4.34 18.85 6 18.85H6.76C7.56 18.85 8.32 19.16 8.88 19.72L10.59 21.41C11.37 22.18 12.64 22.18 13.42 21.41L15.13 19.72C15.69 19.16 16.46 18.85 17.25 18.85H18C19.66 18.85 21 17.52 21 15.88V4.97C21 3.33 19.66 2 18 2ZM12 5.05C13.08 5.05 13.95 5.93 13.95 7C13.95 8.06 13.11 8.91 12.07 8.95C12.03 8.95 11.97 8.95 11.92 8.95C10.87 8.91 10.04 8.06 10.04 7C10.05 5.93 10.92 5.05 12 5.05ZM14.75 15.19C13.24 16.2 10.76 16.2 9.25 15.19C7.92 14.31 7.92 12.85 9.25 11.96C10.77 10.95 13.25 10.95 14.75 11.96C16.08 12.85 16.08 14.3 14.75 15.19Z"/>
      </svg>
        Additional Info
      </div>
      <div className="data-main">
          {
            (data.Address) ? (
              <>
                <div className="normal">Address: {data.Address}</div>
              </>
            ): ""
          }
          {
            (data.BirthYear) ? (
              <>
                <div className="normal">Birthdate: {data.BirthYear}</div>
              </>
            ): ""
          }
          {
            (data.Maried) ? (
              <>
                <div className="normal">Maried: {data.Maried}</div>
              </>
            ): ""
          }
          {
            (data.Gender) ? (
              <>
                <div className="normal">Gender: {data.Gender}</div>
              </>
            ): ""
          }
          
          {
            (data.Gender === "male") ? (
              (data.Military) ? (
                <div className="normal">Military: {MilitaryDict[data.Military]}</div>
              ) : ""
            ) : ""
          }
      </div>
      {/* <div className="block first">
        <div className="side-color"></div>
        <div className="base-data">
          <div className="name">{data.Name}</div>
          <div className="normal">{data.Email} . {data.Mobile}</div>
          {
            (data.Address) ? (
              <>
                <div className="normal">Address: {data.Address}</div>
              </>
            ): ""
          }
          {
            (data.BirthYear) ? (
              <>
                <div className="normal">Birthday: {data.BirthYear}</div>
              </>
            ): ""
          }
          {
            (data.Maried) ? (
              <>
                <div className="normal">Maried: {data.Maried}</div>
              </>
            ): ""
          }
          {
            (data.Gender) ? (
              <>
                <div className="normal">Gender: {data.Gender}</div>
              </>
            ): ""
          }
          
          {
            (data.Gender === "male") ? (
              (data.Military) ? (
                <div className="normal">Military: {MilitaryDict[data.Military]}</div>
              ) : ""
            ) : ""
          }
        </div>
        <div className="expand"></div>
        <div className="image">
          <img src={data.image} alt={"resume avatar"}/>
        </div>
      </div> */}
      {
        (data.Description) ? (
          <>
            <div className="block title">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path opacity="0.4" d="M12 22.01C17.5228 22.01 22 17.5329 22 12.01C22 6.48716 17.5228 2.01001 12 2.01001C6.47715 2.01001 2 6.48716 2 12.01C2 17.5329 6.47715 22.01 12 22.01Z"/>
                <path d="M12 6.93994C9.93 6.93994 8.25 8.61994 8.25 10.6899C8.25 12.7199 9.84 14.3699 11.95 14.4299C11.98 14.4299 12.02 14.4299 12.04 14.4299C12.06 14.4299 12.09 14.4299 12.11 14.4299C12.12 14.4299 12.13 14.4299 12.13 14.4299C14.15 14.3599 15.74 12.7199 15.75 10.6899C15.75 8.61994 14.07 6.93994 12 6.93994Z"/>
                <path d="M18.78 19.36C17 21 14.62 22.01 12 22.01C9.37997 22.01 6.99997 21 5.21997 19.36C5.45997 18.45 6.10997 17.62 7.05997 16.98C9.78997 15.16 14.23 15.16 16.94 16.98C17.9 17.62 18.54 18.45 18.78 19.36Z"/>
              </svg>
              About Me
            </div>
            <div className="block text">
              {(data.Description) ? data.Description : "Not Filled"}
            </div>
          </>
        ) : ""
      }
      {
        (data.DescriptionJob) ? (
          <>
            <div className="block title">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path opacity="0.4" d="M17.53 7.77C17.46 7.76 17.39 7.76 17.32 7.77C15.77 7.72 14.54 6.45 14.54 4.89C14.54 3.3 15.83 2 17.43 2C19.02 2 20.32 3.29 20.32 4.89C20.31 6.45 19.08 7.72 17.53 7.77Z"/>
                <path opacity="0.4" d="M20.7901 14.6999C19.6701 15.4499 18.1001 15.7299 16.6501 15.5399C17.0301 14.7199 17.2301 13.8099 17.2401 12.8499C17.2401 11.8499 17.0201 10.8999 16.6001 10.0699C18.0801 9.86992 19.6501 10.1499 20.7801 10.8999C22.3601 11.9399 22.3601 13.6499 20.7901 14.6999Z"/>
                <path opacity="0.4" d="M6.4399 7.77C6.5099 7.76 6.5799 7.76 6.6499 7.77C8.1999 7.72 9.4299 6.45 9.4299 4.89C9.4299 3.3 8.1399 2 6.5399 2C4.9499 2 3.6499 3.29 3.6499 4.89C3.6599 6.45 4.8899 7.72 6.4399 7.77Z"/>
                <path opacity="0.4" d="M6.55012 12.8501C6.55012 13.8201 6.76012 14.7401 7.14012 15.5701C5.73012 15.7201 4.26012 15.4201 3.18012 14.7101C1.60012 13.6601 1.60012 11.9501 3.18012 10.9001C4.25012 10.1801 5.76012 9.8901 7.18012 10.0501C6.77012 10.8901 6.55012 11.8401 6.55012 12.8501Z"/>
                <path d="M12.12 15.87C12.04 15.86 11.9501 15.86 11.8601 15.87C10.0201 15.81 8.55005 14.3 8.55005 12.44C8.55005 10.54 10.0801 9 11.9901 9C13.8901 9 15.43 10.54 15.43 12.44C15.43 14.3 13.97 15.81 12.12 15.87Z"/>
                <path d="M8.87005 17.9399C7.36005 18.9499 7.36005 20.6099 8.87005 21.6099C10.59 22.7599 13.4101 22.7599 15.1301 21.6099C16.6401 20.5999 16.6401 18.9399 15.1301 17.9399C13.4201 16.7899 10.6 16.7899 8.87005 17.9399Z"/>
              </svg>
              Professional Skills
            </div>
            <div className="block text">
              {(data.DescriptionJob) ? data.DescriptionJob : "Not Filled"}
            </div>
          </>
        ) : ""
      }
      {
        (data.EduBack.length) ? (
          <>
            <div className="block title">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path opacity="0.4" d="M18.38 12.8401V17.7701C18.38 19.0401 17.39 20.4001 16.2 20.8001L13.01 21.8601C12.45 22.0501 11.54 22.0501 10.99 21.8601L7.8 20.8001C6.6 20.4001 5.62 19.0401 5.62 17.7701L5.63 12.8401L10.05 15.7201C11.13 16.4301 12.91 16.4301 13.99 15.7201L18.38 12.8401Z"/>
                <path d="M19.98 6.46006L13.99 2.53006C12.91 1.82006 11.13 1.82006 10.05 2.53006L4.03002 6.46006C2.10002 7.71006 2.10002 10.5401 4.03002 11.8001L5.63002 12.8401L10.05 15.7201C11.13 16.4301 12.91 16.4301 13.99 15.7201L18.38 12.8401L19.75 11.9401V15.0001C19.75 15.4101 20.09 15.7501 20.5 15.7501C20.91 15.7501 21.25 15.4101 21.25 15.0001V10.0801C21.65 8.79006 21.24 7.29006 19.98 6.46006Z"/>
              </svg>

              Education Background
            </div>
            <div className="block items">
              {
                data.EduBack.map((val, i) => {
                  return <Education data={val} key={i}/>
                })
              }
            </div>
          </>
        ) : ""
      }
      {
        (data.JobBack.length) ? (
          <>
          <div className="block title">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21.09 6.98002C20.24 6.04002 18.82 5.57002 16.76 5.57002H16.52V5.53002C16.52 3.85002 16.52 1.77002 12.76 1.77002H11.24C7.48004 1.77002 7.48004 3.86002 7.48004 5.53002V5.58002H7.24004C5.17004 5.58002 3.76004 6.05002 2.91004 6.99002C1.92004 8.09002 1.95004 9.57002 2.05004 10.58L2.06004 10.65L2.16004 11.7C2.17004 11.71 2.19004 11.73 2.21004 11.74C2.54004 11.96 2.88004 12.18 3.24004 12.38C3.38004 12.47 3.53004 12.55 3.68004 12.63C5.39004 13.57 7.27004 14.2 9.18004 14.51C9.27004 15.45 9.68004 16.55 11.87 16.55C14.06 16.55 14.49 15.46 14.56 14.49C16.6 14.16 18.57 13.45 20.35 12.41C20.41 12.38 20.45 12.35 20.5 12.32C20.96 12.06 21.39 11.78 21.81 11.47C21.83 11.46 21.85 11.44 21.86 11.42L21.9 11.06L21.95 10.59C21.96 10.53 21.96 10.48 21.97 10.41C22.05 9.40002 22.03 8.02002 21.09 6.98002ZM13.09 13.83C13.09 14.89 13.09 15.05 11.86 15.05C10.63 15.05 10.63 14.86 10.63 13.84V12.58H13.09V13.83ZM8.91004 5.57002V5.53002C8.91004 3.83002 8.91004 3.20002 11.24 3.20002H12.76C15.09 3.20002 15.09 3.84002 15.09 5.53002V5.58002H8.91004V5.57002Z"/>
            <path opacity="0.4" d="M20.5 12.3C20.45 12.33 20.4 12.36 20.35 12.39C18.57 13.43 16.6 14.13 14.56 14.47C14.48 15.43 14.06 16.53 11.87 16.53C9.68003 16.53 9.26003 15.44 9.18003 14.49C7.27003 14.19 5.39003 13.56 3.68003 12.61C3.53003 12.53 3.38003 12.45 3.24003 12.36C2.88003 12.16 2.54003 11.94 2.21003 11.72C2.19003 11.71 2.17003 11.69 2.16003 11.68L2.77003 18.19C2.98003 20.18 3.80003 22.23 8.20003 22.23H15.82C20.22 22.23 21.04 20.18 21.25 18.18L21.88 11.4C21.87 11.42 21.85 11.44 21.83 11.45C21.4 11.76 20.96 12.05 20.5 12.3Z"/>
          </svg>

            Job Experience
          </div>
          <div className="block items">
            {
              data.JobBack.map((val, i) => {
                return <Jobs data={val} key={i}/>
              })
            }
          </div>
          </>
        ) : ""
      }
      {
        (data.LanBack.length) ? (
          <>
          <div className="block title">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path opacity="0.4" d="M16.9201 22C14.1201 22 11.8401 19.73 11.8401 16.92C11.8401 14.12 14.1101 11.84 16.9201 11.84C19.7201 11.84 22.0001 14.11 22.0001 16.92C22.0001 19.73 19.7301 22 16.9201 22Z"/>
              <path opacity="0.4" d="M5.02 2H8.94C11.01 2 12.01 2.99999 11.96 5.01999V8.94C12.01 11.01 11.01 12.01 8.94 11.96H5.02C3 12 2 11 2 8.92999V5.01001C2 3.00001 3 2 5.02 2Z"/>
              <path d="M9.00993 8.26004C8.69993 8.26004 8.40994 8.14003 8.13994 7.94003C8.38994 7.54003 8.56994 7.09004 8.65994 6.60004H8.99994C9.40994 6.60004 9.74994 6.26004 9.74994 5.85004C9.74994 5.44004 9.40994 5.10004 8.99994 5.10004H8.00993C7.99993 5.10004 7.98994 5.10004 7.98994 5.10004H7.96994H7.70995C7.66995 4.72004 7.35994 4.42004 6.96994 4.42004C6.57994 4.42004 6.26993 4.72004 6.22993 5.10004H4.93994C4.52994 5.10004 4.18994 5.44004 4.18994 5.85004C4.18994 6.26004 4.52994 6.60004 4.93994 6.60004H7.10994C6.80994 7.56004 5.94993 8.26004 4.92993 8.26004C4.51993 8.26004 4.17993 8.60004 4.17993 9.01004C4.17993 9.42004 4.51993 9.76004 4.92993 9.76004C5.73993 9.76004 6.48994 9.49004 7.10994 9.04004C7.65994 9.50004 8.31994 9.76004 8.99994 9.76004C9.40994 9.76004 9.74994 9.42004 9.74994 9.01004C9.74994 8.60004 9.41993 8.26004 9.00993 8.26004Z"/>
              <path d="M9 22.75C4.73 22.75 1.25 19.27 1.25 15C1.25 14.59 1.59 14.25 2 14.25C2.41 14.25 2.75 14.59 2.75 15C2.75 17.96 4.81 20.44 7.58 21.09L7.31 20.64C7.1 20.28 7.21001 19.82 7.57001 19.61C7.92001 19.4 8.39001 19.51 8.60001 19.87L9.64999 21.62C9.78999 21.85 9.79 22.14 9.66 22.37C9.52 22.6 9.27 22.75 9 22.75Z"/>
              <path d="M21.9999 9.75C21.5899 9.75 21.2499 9.41 21.2499 9C21.2499 6.04 19.1899 3.56 16.4199 2.91L16.6899 3.35999C16.8999 3.71999 16.7899 4.18001 16.4299 4.39001C16.0799 4.60001 15.6099 4.49001 15.3999 4.13L14.3499 2.38C14.2099 2.15 14.2099 1.86 14.3399 1.63C14.4699 1.39 14.7199 1.25 14.9899 1.25C19.2599 1.25 22.7399 4.73 22.7399 9C22.7499 9.41 22.4099 9.75 21.9999 9.75Z"/>
              <path d="M19.73 18.33L17.59 14.06C17.46 13.81 17.2 13.64 16.92 13.64C16.64 13.64 16.38 13.8 16.25 14.05L14.11 18.32C13.92 18.69 14.07 19.14 14.45 19.33C14.56 19.38 14.67 19.41 14.78 19.41C15.05 19.41 15.32 19.26 15.45 19L15.62 18.66H18.2101L18.38 19C18.57 19.37 19.02 19.52 19.39 19.34C19.77 19.15 19.92 18.7 19.73 18.33ZM16.38 17.16L16.93 16.07L17.48 17.16H16.38Z"/>
            </svg>
            Languages
          </div>
          <div className="block items">
            {
              data.LanBack.map((val, i) => {
                return <Language data={val} key={i}/>
              })
            }
          </div>
          </>
        ) : ""
      }
    </StyleCss>
  );
}
export default ResumeDataShow;



function Jobs (props) {
  let data = props.data
  return (
    <div className="row data">
      <div className="right">
        <div className="top">
          {data.JobTitle}
        </div>
        <div className="small">
          {data.companyName}
        </div>
      </div>
      <div className="left">
        <FormatDate InDate={data.InDate} OutDate={data.OutDate}/>
      </div>
    </div>
  )
}

function Education (props) {
  let data = props.data
  return (
    <div className="row data">
      <div className="right">
        <div className="top">
          {data.EduName} - {data.EduTitle}
        </div>
        <div className="small">
          {data.Where}
        </div>
      </div>
      <div className="left">
        <FormatDate InDate={data.InDate} OutDate={data.OutDate}/>
      </div>
    </div>
  )
}
function Language (props) {
  let data = props.data
  return (
    <div className="row data">
      <div className="right">
        {data.LanTitle}
      </div>
      <div className="left">
        {data.Level}
      </div>
    </div>
  )
}



function FormatDate(props) {
  let inDate = props.InDate.split("/");
  let outDate = props.OutDate.split("/");
  inDate.reverse()
  outDate.reverse()
  inDate = inDate.join('/')
  outDate = outDate.join('/')
  return (
    <>
      <div className="date-in">
        from {inDate}
      </div>
      <div className="data-out">
        to {outDate}
      </div>
    </>
  )
}


const MilitaryDict = {
  no:"Not served",
  yes: "Served",
  Exemption:"Exemption",
}